import type { DashboardNotificationSeverity } from "@situate/contracts/runtime";
import type { StatusBadgeSeverity } from "@/shared/ui";

const DEFAULT_PREVIEW_COUNT = 1;

export function getDefaultNotificationPreviewCount(): number {
  return DEFAULT_PREVIEW_COUNT;
}

/** Maps a contract severity onto StatusBadge's semantic palette for display. */
export function toStatusBadgeSeverity(
  severity: DashboardNotificationSeverity
): StatusBadgeSeverity {
  return severity;
}
